// extracted by mini-css-extract-plugin
export default {"container":"banner_container__1tbjb","banner":"banner_banner__NyvIT","left":"banner_left__MDsOv","right":"banner_right__wSxrR"};